import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ClubPlansListApi = (data) => API.get(`${URL.CLUB_PLANS_LIST}`, data)
export const PlansDetailApi = (ID) => API.get(`${URL.PLAN_DETAIL_URL}/${ID}`)
export const AddPlanPaymentApi = (data) => API.post(`${URL.ADD_PLAN_PAYMENT}`, data)
export const SuccessPlanPaymentApi = (data) => API.post(`${URL.SUCCESS_PLAN_PAYMENT}`, data)
